import styled from 'styled-components';

export const PrimaryButtonContainer = styled.button`
  border: none;
  background: ${({ disabled }) =>
    disabled
      ? `var(--grey)`
      : `linear-gradient(
  180deg,
  rgba(254, 210, 66, 1) 4%,
  rgba(253, 220, 94, 1) 31%,
  rgba(242, 175, 23, 1) 100%
)`};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  color: var(--grey6) !important;
  font-weight: 600;
  padding: 0.8rem 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-weight: 600 !important;
  letter-spacing: 0.1rem !important;
  text-transform: uppercase !important;
  font-style: normal !important;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  /* color: ${({ theme }) => theme.colors.grey6}; */
  &:hover {
    background: var(--orange4);
    transform: scale(1.08);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
    color: ${({ theme }) => theme.colors.grey7};

    /* color: var(--white); */
  }
  &:active {
    background: var(--orange5);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
    /* color: var(--white); */
  }
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.xl};
  font-weight: bold;
  transform: ${({ active }) => (active ? 'scale(1.08)' : 'scale(1)')};
  transition:
    background 0.2s,
    color 0.2s,
    transform 0.2s;
  /* font-size: 0.7rem; */
`;
